import { render, staticRenderFns } from "./SafeIcon.vue?vue&type=template&id=76f89110&"
import script from "./SafeIcon.vue?vue&type=script&lang=ts&"
export * from "./SafeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports